import { Typography } from '@navi/web-ui/lib/primitives';
import React from 'react';

const ValidationsContainer = (props: {
  validationName: string;
  validationIcon: React.ReactNode;
}) => {
  const { validationName, validationIcon } = props;
  return (
    <div className="flex items-center justify-between mb-2">
      <Typography variant="h4" color="var(--grayscale-3)">
        {validationName}
      </Typography>
      {validationIcon}
    </div>
  );
};

export default ValidationsContainer;
